import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

import useLocalStorage from '../../hooks/useLocalStorage';
import { ModalContext } from '../../context';
import settings from '../../config';
import deleteIcon from '../../imgs/delete.png';
import editIcon from '../../imgs/edit.png';
import Header from '../Header';

const AssetDetails = () => {
  const [assetDetails, setAssetDetails] = useState([]);
  const { assetId } = useParams();
  const [admin] = useLocalStorage('admin');
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}assets/details`, {
        assetId
      });

      if (response.data.statusCode === 200) {
        setAssetDetails(response.data.data);
      }
    })();
  }, [assetId]);

  const deleteBillCategoryInstalment = async (assetDetailId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}assets/delete-details`,
          {
            assetDetailId
          }
        );

        if (response.data.statusCode === 200) {
          setAssetDetails(
            assetDetails.filter(
              (assetDetail) => assetDetailId !== assetDetail.assetDetailId
            )
          );
        }
      }
    });
  };

  let total = 0;

  return (
    <div className='w-full'>
      <Header text='اضافه تفاصيل اصل' link={`/asset/details/form/${assetId}`} />
      <table className='w-full table-auto border-separate border-spacing-1 text-right '>
        <thead>
          <tr>
            <th>اسم تفاصيل الاصل</th>
            <th>العدد</th>
            <th>السعر للقطعه</th>
            <th>السعر الاجمالى</th>
            <th>تاريخ</th>
            {admin.canEdit === 1 && <th className='text-center w-24'>تعديل</th>}
            {admin.canDelete === 1 && <th className='text-center w-24'>حذف</th>}
          </tr>
        </thead>
        <tbody>
          {assetDetails.map((assetDetail) => {
            total += assetDetail.price * assetDetail.quantity;

            return (
              <tr
                key={assetDetail.assetDetailId}
                className='bg-white odd:bg-gray-100'
              >
                <td>{assetDetail.assetName}</td>
                <td>{assetDetail.quantity}</td>
                <td>{assetDetail.price}</td>
                <td>{assetDetail.price * assetDetail.quantity}</td>
                <td>{assetDetail.instalmentDate}</td>
                {admin.canEdit === 1 && (
                  <td className='text-center'>
                    <Link
                      to={`/asset/details/form/${assetId}/${assetDetail.assetDetailId}`}
                      className='flex flex-col items-center w-full cursor-pointer'
                    >
                      <img src={editIcon} alt='edit' className='h-10' />
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className='text-center'>
                    <div
                      className='flex flex-col items-center w-full cursor-pointer'
                      onClick={() =>
                        deleteBillCategoryInstalment(assetDetail.assetDetailId)
                      }
                    >
                      <img src={deleteIcon} alt='delete' className='h-5' />
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
          <tr>
            <td className='text-rose-500'>اجمالى المدفوع</td>
            <td></td>
            <td></td>
            <td className='text-rose-500'>{total}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AssetDetails;
